"use client";

import { Onborda } from "onborda";
import { FC, createContext, useContext, useEffect, useState } from "react";

import { CustomCard } from "@/components/stepper";
import { useRouter } from "@/lib/i18n";
import steps from "@/lib/steps";

import { DatabaseCleaner } from "../db/clear";

export const AdminContext = createContext({
  setIsConnected: (x: any) => {
    return x;
  },
  connectedUser: "",
  setConnectedUser: (x: any) => {
    return x;
  },
});

const AdminProvider: FC<{ children: any }> = ({ children }) => {
  const { push } = useRouter();

  const [connectedUser, setConnectedUser] = useState<string | null>();
  const [isConnected, setIsConnected] = useState<boolean>(false);

  useEffect(() => {
    if (typeof localStorage !== "undefined") {
      setIsConnected(!!localStorage.getItem("connectedUserId"));
    }
  }, []);

  const contextValue = { setIsConnected, connectedUser, setConnectedUser };

  return (
    <AdminContext.Provider value={contextValue as any}>
      {isConnected && (
        <div className="flex flex-row w-full bg-destructive h-[44px] py-4 items-center justify-center gap-8 sticky top-0 z-[1000] exclude-weglot">
          <p className="font-bold text-white">{`You are connected as user with ID: ${localStorage.getItem(
            "connectedUserId",
          )} and FBId: ${localStorage.getItem("connectedUserFBId")}`}</p>
          <button
            className="border px-2 rounded-sm font-medium text-white"
            onClick={async () => {
              await DatabaseCleaner.clearDatabase({
                backup: false,
                clearAnalytics: false,
                clearHoldings: true,
                clearKeys: true,
                clearSnapshots: true,
              });
              setTimeout(() => {
                localStorage.removeItem("connectedUserId");
                setIsConnected(false);
                setConnectedUser(null);
                push("/admin");
              }, 2000);
            }}
          >
            Disconnect
          </button>
        </div>
      )}
      <Onborda cardComponent={CustomCard} steps={steps as any}>
        {children}
      </Onborda>
    </AdminContext.Provider>
  );
};

export const useAdmin = () => useContext(AdminContext);

export default AdminProvider;
